module.exports = "<div class=\"l-wrapper\">\n    <!-- 04-00-00_facturas -->\n    <div class=\"l-sidebar-wrapper\">\n        <bills-list [bills]=\"bills\" [paid]=\"paid\" [type]=\"type\" class=\"l-sidebar-wrapper__item\"></bills-list>\n        <bills-search (searchBillsEmitter)=\"searchBills($event)\" (filterByPaidEmitter)=\"setFilterPaid($event)\" class=\"l-sidebar-wrapper__item\"></bills-search>\n    </div>\n    <!-- END 04-00-00_facturas -->\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/bills/templates/main-bills.html
// module id = ./src/app/modules/bills/templates/main-bills.html
// module chunks = main